import { useTranslation } from 'react-i18next';
import { Button } from 'antd';
import {
  useGenerateOfferingsReportMutation,
  useGetProjectHomeInfoQuery,
} from '@/redux';

interface Props {
  projectId: string;
  homeId: string;
  className?: string;
}

const useSubmit = (homeId: string) => {
  const [generate] = useGenerateOfferingsReportMutation();

  return () =>
    generate({ homeId })
      .unwrap()
      .then((uri: string) => {
        window.open(
          '/api/report/inline?src=' + encodeURIComponent(uri),
          '_blank',
        );
      });
};

export function HomesOfferingsReportButtonPanel(props: Props) {
  const { projectId, homeId, className } = props;
  const { t } = useTranslation();
  const { data } = useGetProjectHomeInfoQuery({ id: projectId, homeId });
  const submit = useSubmit(homeId);

  return (
    <Button
      type="primary"
      onClick={submit}
      disabled={!data?.isActive}
      className={className}
    >
      {t('reports.offeringsReportButton')}
    </Button>
  );
}
